import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { PanelsComponent } from "./panels.component";
import { SidePanelDirectSearchComponent } from "./side-panel/side-panel-direct-search/side-panel-direct-search.component";
import { SidePanelProductsComponent } from "./side-panel/side-panel-products/side-panel-products.component";
import { SidePanelTagsComponent } from "./side-panel/side-panel-tags/side-panel-tags.component";
import { SidePanelTitleComponent } from "./side-panel/side-panel-title/side-panel-title.component";
import { SidePanelComponent } from "./side-panel/side-panel.component";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DirectSearchFormComponent } from "src/app/pages/direct-search/direct-search-form/direct-search-form.component";
import { BannerComponent } from "../banner/banner.component";

@NgModule({
    declarations: [
        PanelsComponent,
        PanelsComponent,
        SidePanelComponent,
        SidePanelTitleComponent,
        SidePanelProductsComponent,
        SidePanelTagsComponent,
        SidePanelDirectSearchComponent,
    ],
    exports: [
        PanelsComponent,
        SidePanelComponent
    ],
    imports: [
        // Angular
        CommonModule,

        //Material
        MatProgressSpinnerModule,
        MatTooltipModule,

        // App
        DirectSearchFormComponent,
        BannerComponent
    ]
})
export class PanelsModule {}